module.exports = __webpack_public_path__ + "img/trade_alt.f67128e1.svg";